import { ChampagneBubbles } from "./bubbles";
import { motion } from "framer-motion";
import { Shake } from "./shake";

import childrens from "./images/фото-детей.png";
import ourcat from "./images/картинка-рон.png";
import weare from "./images/машавалера.png";
import arrow from "./images/arrow.png";
import frame from "./images/рамка1.png";
import wife from "./images/невеста.png";
import groom from "./images/жених.png";

import c10 from "./images/c10.png";
import c9 from "./images/c9.png";
import c8 from "./images/c8.png";
import c7 from "./images/c7.png";
import c6 from "./images/c6.png";
import c5 from "./images/c5.png";
import c4 from "./images/c4.png";
import c3 from "./images/c3.png";
import c2 from "./images/c2.png";
import c1 from "./images/c1.png";

export const Hero = () => {
  const leftHeartSide = [
    {
      image: c6,
      alt: "c6",
      className: "absolute w-[10%] top-[15%] -left-[3%]",
    },
    {
      image: c7,
      alt: "c7",
      className: "absolute w-[10%] top-[30%] -left-[5%]",
    },
    {
      image: c10,
      alt: "c10",
      className: "absolute w-[10%] top-[40%] -left-[25%]",
    },
    {
      image: c9,
      alt: "c9",
      className: "absolute w-[10%] top-[55%] -left-[40%]",
    },
    {
      image: c8,
      alt: "c8",
      className: "absolute w-[10%] top-[72%] -left-[16%]",
    },
  ];

  const rightHeartSide = [
    {
      image: c1,
      alt: "c1",
      className: "absolute w-[10%] top-[15%] -right-[10%]",
    },
    {
      image: c5,
      alt: "c5",
      className: "absolute w-[10%] top-[30%] right-[5%]",
    },
    {
      image: c2,
      alt: "c2",
      className: "absolute w-[10%] top-[43%] -right-[5%]",
    },
    {
      image: c3,
      alt: "c3",
      className: "absolute w-[10%] top-[55%] -right-[30%]",
    },
    {
      image: c4,
      alt: "c4",
      className: "absolute w-[5%] top-[72%] -right-[6%]",
    },
  ];

  return (
    <section className="w-full pb-10 sm:pb-18">
      <div className="relative">
        <img src={frame} alt="" aria-hidden="true" className="w-full h-auto" />

        <div className="absolute left-1/2 top-[40%] w-[55%] -translate-x-1/2 -translate-y-1/2">
          <div className="relative">
            <img
              src={weare}
              alt="Мы"
              className="absolute left-1/2 top-[-40%] w-[84%] -translate-x-1/2"
            />

            <div className="relative w-full">
              <motion.img
                src={groom}
                alt="Жених"
                className="absolute left-[-6%] top-[14%] w-[23.5%] -translate-y-1/2 object-contain"
                animate={{ rotate: [0, -10, 10, -10, 10, 0] }}
                transition={{
                  duration: 4.2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />

              <motion.img
                src={wife}
                alt="Невеста"
                className="absolute right-[-10%] top-[14%] w-[30.5%] -translate-y-1/2 object-contain"
                animate={{ rotate: [0, -10, 10, -10, 10, 0] }}
                transition={{
                  duration: 4.2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            </div>

            <img
              src={childrens}
              alt="Валера и Маша в детстве"
              className="w-full h-auto"
            />

            <div className="absolute inset-x-[12%] bottom-[2.5%] flex h-[12%] items-center justify-center">
              <p className="w-full text-center font-bold text-[0.95rem] leading-none text-(--text-inverse) sm:text-base">
                Мы женимся!
              </p>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-[-8%] w-[43%]">
          <div className="relative ">
            <div className="absolute left-0 -top-4 w-[33%] -translate-x-[35%] -translate-y-1/2 flex flex-col items-center">
              <span className="text-[var(--text-accent)]">Ронечка</span>
              <motion.img
                src={arrow}
                className="w-7"
                animate={{ rotate: [0, -10, 10, -10, 10, 0] }}
                transition={{
                  duration: 4.2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            </div>

            <div className="relative">
              <img src={ourcat} alt="Наш кот Рон" />

              <ChampagneBubbles className="absolute top-15 right-12" />

              <div className="absolute inset-0">
                {leftHeartSide.map(({ image, alt, className }) => (
                  <Shake
                    key={alt}
                    src={image}
                    alt={alt}
                    className={className}
                  />
                ))}
              </div>

              <div className="absolute inset-0">
                {rightHeartSide.map(({ image, alt, className }) => (
                  <Shake
                    key={alt}
                    src={image}
                    alt={alt}
                    className={className}
                  />
                ))}
              </div>
            </div>

            <p className="mt-4 w-[175%] -translate-x-[17.5%] text-center text-sm text-(--text-accent) sm:mt-5">
              - Наконец-то! Главное чтобы моя кровать не стала уже, <br /> а
              корм - хуже.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
